export const TEXT = {
  EVENTS_ERROR: "Events Error",
  EVENTS_ERROR_DESC: "Failed to fetch events",
  EVENTS_DETAILS_ERROR_DESC: "Failed to fetch event details",
  ERROR_TEMPLATE_TITLE: "Something went wrong",
  ERROR_TEMPLATE_DESC: "An error occurred. Please try refreshing the page.",
  CAMERA_ERROR: "Unable to load cameras",
  CAMERA_ERROR_DESC: "Something went wrong while fetching camera data. Please try again.",
  CAMERA_NOT_FOUND_ERROR: "Camera not found",
  CAMERA_NOT_FOUND_DESC: "Camera either deleted or unpaired. Click refresh to navigate to devices",
  CCD_NOT_FOUND_ERROR: "Companion device not found",
  CCD_NOT_FOUND_DESC: "Companion device either deleted or removed. Click refresh to navigate to devices",
  EVENT_NOT_FOUND_ERROR: "Event not found",
  EVENT_NOT_FOUND_DESC: "The event may have been deleted or the link is invalid. Click refresh to navigate to events",
  VIDEO_LOAD_ERROR_TITLE: "Event snapshot &",
  VIDEO_LOAD_ERROR_DESC: "Evidence video is not received yet",
  LIVE_STREAM_ERROR: "Live Stream Error",
  CAMERA_NOT_AVAILABLE_ERROR: "Camera not available to stream",
  LIVE_STREAM_DESC: "Unable to stream at this point of time",
  CAMERA_NOT_AVAILABLE_DESC: "Unable to stream because camera is not paired with CCD.",
  ASSOCIATED_CAMERA_ERROR: "Associated Cameras Error",
  ASSOCIATED_CAMERA_DESC: "Failed to fetch associated cameras",
  DISCOVER_CAMERA_ERROR: "Discover Camera Error",
  DISCOVER_CAMERA_DESC: "Failed to retrieve discovered cameras",
  NO_CAMERAS_FOUND: "No cameras found",
  NO_CAMERAS_FOUND_DESC: "No cameras have been added to this account yet.",
  NO_STREAMS_FOUND: "No cameras found",
  NO_STREAMS_FOUND_DESC: "No cameras have been paired to this companion device yet.",
  RULES_FETCH_ERROR: "Unable to load alerts",
  RULES_FETCH_ERROR_DESC: "Something went wrong while fetching alerts. Please try again.",
  NO_RULES_FOUND: "No alerts found",
  NO_RULES_FOUND_DESC: "No alerts have been created for this account yet."
};
